module.exports = __webpack_public_path__ + "static/farmacias-topo-386bfaa69e9c3344950835a2c7488318.svg";